export const SERVICE_PREFAB_SWAPOUT = {
    label: 'Prefab Swap-out does not include running electrical or gas lines',
    value: 'SERVICE_PREFAB_SWAPOUT'
}